import createMuiTheme from '@material-ui/core/styles/createTheme';

import theme from "./theme";

export default createMuiTheme(theme);
